let extension = {
  top_title:"this is content"
}
export default extension


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_extension/index.js